import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const studyEventManagementServices = {
  //Event Column
  addNewStudyEventColumn,
  updateStudyEventColumnData,
  deleteStudyEventColumnData,
  softDeleteRestoreStudyEventColumn,
  getStudyEventColumnData,

  //Event Row
  addNewStudyEventRow,
  addStudyTimepointEventRow,
  uploadStudyEventRow,
  updateStudyEventRowData,
  updateStudyEventRowStatus,
  updateStudyEventRowOrderData,
  deleteStudyEventRowData,
  softDeleteRestoreStudyEventRow,
  getStudyEventRowData,
  getStudyEventByType,
  getSingleStudyEventData,
  exportStudyEventRowJsonData,
  getHeighestVersionEventRowHistory,
  getStudyEventAuditTrials,
  assignUnassignStudySubjectEventUnscheduledForm,
  softDeleteRestoreStudySubjectEventUnscheduledForm,
  getAssignedSubjectEventUnscheduledForm,

  //Event Schema
  assignUnassignStudyEventForm,
  assignUnassignStudyUnscheduledEventForm,
  getFormEventBasedonSchema,
  getFormUnscheduledEventBasedonSchema,
  getInitiateFormEventBasedonSchema,
  assignUnassignStudySiteSchema,
  getAssignedSchemainSite,
  assignUnassignStudySpecialForm,
  deleteStudyEventSchema,
  updateStatusStudyEventSchema,
  getStudyEventSchema,
  getAssignedEventForm,
  getAssignedUnscheduledEventForm,
  getAssignedUnscheduledEventFormForSubjectEventAssign,
  getSchemaEventForms,
  getSpecialEventFormBySchema,
  getInitiatedEventFormByEvent,
  assignUnassignStudyInitiateForm
};

// Get Study Event Column
async function getStudyEventColumnData(status, studyId, type, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventColumnData/${status}/${studyId}/${type}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventColumnData/${status}/${studyId}/${type}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Event Column
async function addNewStudyEventColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyEventColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Column
async function updateStudyEventColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Column
async function softDeleteRestoreStudyEventColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyEventColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Column
async function deleteStudyEventColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event By Type
async function getStudyEventByType(status, studyId, eventId, type, searchData) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyEventByType/${status}/${studyId}/${eventId}/${type}?search=${searchData || ""}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Single Study Event
async function getSingleStudyEventData(studyId, eventId, timePointUniqueId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleStudyEventData/${studyId}/${eventId}/${timePointUniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Row
async function getStudyEventRowData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventRow/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEventRow/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Export Study Event Row Json Data
async function exportStudyEventRowJsonData(studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportStudyEventRowJsonData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add New Study Event Row
async function addNewStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyEventRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add New Study Time Point Event Row
async function addStudyTimepointEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addStudyTimepointEventRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Assign and Unassign Study Subject Event Unscheduled Form
async function assignUnassignStudySubjectEventUnscheduledForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudySubjectEventUnscheduledForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Study Subject Event Unscheduled Form
async function softDeleteRestoreStudySubjectEventUnscheduledForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectEventUnscheduledForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Assigned Subject Event Unscheduled Form
async function getAssignedSubjectEventUnscheduledForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedSubjectEventUnscheduledForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Upload Event Study Event Row
async function uploadStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}uploadStudyEventRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Event Row
async function updateStudyEventRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Event Row Status
async function updateStudyEventRowStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventRowStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Event Order
async function updateStudyEventRowOrderData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyEventRowOrderData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Event Row
async function softDeleteRestoreStudyEventRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyEventRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Row
async function deleteStudyEventRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event Row Heighest version
async function getHeighestVersionEventRowHistory(studyId, eventId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getHeighestVersionEventRowHistory/${studyId}/${eventId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Form Event Based on Schema with Form
async function getFormEventBasedonSchema(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getFormEventBasedonSchema/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Form Unscheduled Event Based on Schema with Form
async function getFormUnscheduledEventBasedonSchema(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getFormUnscheduledEventBasedonSchema/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Initiate Form Event Based on Schema with Form
async function getInitiateFormEventBasedonSchema(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getInitiateFormEventBasedonSchema/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Event Row
async function getStudyEventAuditTrials(studyId, eventId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyEventAuditTrials/${studyId}/${eventId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Assign Unassign Study Event Schema
async function assignUnassignStudyEventForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudyEventForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Assign Unassign Study Unscheduled Event Schema
async function assignUnassignStudyUnscheduledEventForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudyUnscheduledEventForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Assign and unassign Study Site Schema
async function assignUnassignStudySiteSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudySiteSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Assign Unassign Study Special Schema
async function assignUnassignStudySpecialForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudySpecialForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Soft Delete & Restore Study Event Schema
async function updateStatusStudyEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStatusStudyEventSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Event Schema
async function deleteStudyEventSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyEventSchema`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Event Schema
async function getStudyEventSchema(status, studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyEventSchema/${status}/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assigned Initiate Form
async function getInitiatedEventFormByEvent(studyId, schemaId, eventId, timePointUniqueId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getInitiatedEventFormByEvent/${studyId}/${schemaId}/${eventId}/${timePointUniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assigned Event Form
async function getAssignedEventForm(studyId, schemaId, eventId, timePointUniqueId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedEventForm/${studyId}/${schemaId}/${eventId}/${timePointUniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assigned Unscheduled Event Form
async function getAssignedUnscheduledEventForm(studyId, schemaId, eventId, timePointUniqueId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedUnscheduledEventForm/${studyId}/${schemaId}/${eventId}/${timePointUniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assigned Unscheduled Event Form for Subject Event Assign
async function getAssignedUnscheduledEventFormForSubjectEventAssign(studyId, schemaId, eventId, timePointUniqueId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedUnscheduledEventFormForSubjectEventAssign/${studyId}/${schemaId}/${eventId}/${timePointUniqueId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Assigned Schema in Site
async function getAssignedSchemainSite(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedSchemainSite/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Find Form Based on Schema and Event
async function getSchemaEventForms(studyId, schemaId, eventId, timePointId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSchemaEventForms/${studyId}/${schemaId}/${eventId}/${timePointId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Special Event Form By Schema
async function getSpecialEventFormBySchema(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSpecialEventFormBySchema/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}


// Assign and Unassign Study Initiate Schema
async function assignUnassignStudyInitiateForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudyInitiateForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data
}